import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchTrainers } from "../API/API";
import "../styles/TrainerProfile.css";


const dummyTrainers = [
  {
    name: "Manikonda Sharat",
    course: "AI, ML, Data Science, Data Engineering, MLOps",
    contact: "+91-9885088485",
    email: "manikondasharat@gmail.com",
    photo: "/images/Sharatsir.jpg",
    demoVideo: "https://www.youtube.com/watch?v=PGeBdvgYVNA",
  },
  {
    name: "Kanhiyalal .k",
    course: "AWS, Azure, OCI & Multi Cloud Architect",
    contact: "+91-8978266997",
    email: "kanhiyalal.kushwaha@gmail.com",
    photo: "/images/kanhaiyalal-photo.jpg",
    demoVideo:"",
  },
  {
    name: "Deepak .B",
    course: "Data Science, Data analytics",
    contact: "+91-8978266997",
    email: "kanhiyalal.kushwaha@gmail.com",
    photo: "/images/DeepakB.png",
    demoVideo:"https://www.youtube.com/watch?v=PM1v7CfJy0U ",
  }
  
];

const TrainerProfile = () => {
  const [trainers, setTrainers] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);



  useEffect(() => {
     const token = localStorage.getItem("authToken");
    setIsLoggedIn(!!token);

    const loadTrainers = async () => {
      try {
        const res = await fetchTrainers();
        const data = res.data || [];
        
        setTrainers(data.length > 0 ? data : dummyTrainers);
      } catch (error) {
        console.error("Error fetching trainers. Showing dummy data instead.", error);
        setTrainers(dummyTrainers); 
      }
    };

    loadTrainers();
  }, []);
  

  return (
    // <div className="trainer-profiles-container">
    //   {trainers.map((trainer, index) => (
    //     <div className="trainer-profile-card" key={index}>
    //       {trainer.photo ? (
    //         <img
    //           src={trainer.photo}
    //           alt={`${trainer.name}'s profile`}
    //           className="trainer-profile-pic"
    //         />
    //       ) : (
    //         <div className="trainer-profile-placeholder">No Photo</div>
    //       )}

    //       <div className="trainer-profile-details">
    //         <h2>{trainer.name}</h2>
    //         <p><strong>Skills:</strong> {trainer.course}</p>

    //         <div className="trainer-watch-link" style={{ marginTop: "10px" }}>
    //           <Link
    //             to="/freelancer-trainer"
    //             style={{
    //               textDecoration: "none",
    //               color: "#007BFF",
    //               fontWeight: "bold",
    //             }}
    //           >
    //             ▶ Watch Demo Video
    //           </Link>
    //         </div>

    //         <div className="trainer-contact-hidden">
    //           <details>
    //             <summary>Contact Details</summary>
    //             <p><strong>Phone:</strong> {trainer.contact}</p>
    //             <p><strong>Email:</strong> {trainer.email}</p>
    //           </details>
    //         </div>
    //       </div>
    //     </div>
    //   ))}
  
      <div className="trainer-profiles-wrapper">

        {trainers.map((trainer, index) => (
          <div className="trainer-profile-card" key={index}>
            <div className="image-holder">
            {trainer.photo ? (
              <img
                src={trainer.photo}
                alt={`${trainer.name || "Trainer"}'s profile`}
                className="trainer-profile-pic"
              />
            ) : (
              <div className="trainer-profile-placeholder">No Photo</div>
            )}
           </div>
            <div className="trainer-profile-details">
              <div className="trainer-profile-content">
              <h2>{trainer.name}</h2>
              <h4><span className="skill-label">Skills:</span> {trainer.course}</h4>

  
              <div className="trainer-watch-link">
                <Link
                  to={trainer.demoVideo ? trainer.demoVideo : "/freelancer-trainer"}
                  target={trainer.demoVideo ? "_blank" : "_self"}
                  rel="noopener noreferrer"
                   className="trainer-demo-link"
                >
                  ▶ Watch Demo Video
                </Link>
              </div>
  
                  {isLoggedIn && (
                <div className="trainer-contact-hidden">
                  <details>
                    <summary>Contact Details</summary>
                    <p><strong>Phone:</strong> {trainer.contact}</p>
                    <p><strong>Email:</strong> {trainer.email}</p>
                  </details>
                </div>
              )}
              
            

              {!isLoggedIn && (
                
                <p className="trainer-login-note">
                
                  Login to view contact details.
                </p>
              )}
  
              <Link
                to={`/TrainerDetails`}
                state={{ trainer }}
                className="trainer-view-button"
              >
                VIEW
              </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };
  
  export default TrainerProfile;
  

    